import { render, staticRenderFns } from "./tabRailwayHeadwayTail.vue?vue&type=template&id=56328f0f&"
import script from "./tabRailwayHeadwayTail.vue?vue&type=script&lang=js&"
export * from "./tabRailwayHeadwayTail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('56328f0f')) {
      api.createRecord('56328f0f', component.options)
    } else {
      api.reload('56328f0f', component.options)
    }
    module.hot.accept("./tabRailwayHeadwayTail.vue?vue&type=template&id=56328f0f&", function () {
      api.rerender('56328f0f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/RailwayExport/components/booking/tabs/tabRailwayHeadwayTail.vue"
export default component.exports